/**
 * Device-local memory of the team's Market War (eager, tiny, type-only imports): which war was
 * seen last and whether its results card was shown. Player-tagged like the teams memo (same
 * helpers). It holds no standings and no counts of its own: the card reads GET /v1/war/last, so
 * everything it shows is the API's.
 */
import type { AppContext } from '../../game/context.js';
import { readMemo, writeMemo } from '../teams/cache.js';

type Ctx = Pick<AppContext, 'services'>;

const WAR_KEY = 'feature.war.memo';

export interface WarMemo {
  warId: string;
  /** the planned end: an operator may settle a war earlier (see goneAt) */
  endsAt: number;
  /** server instant the API first stopped listing the war before its planned end while the player was still in the team: it ended early */
  goneAt?: number;
  teamId: string;
  /** the results card was shown for this war */
  shown: boolean;
}

export function warMemo(a: Ctx): WarMemo | null {
  return readMemo<WarMemo>(a, WAR_KEY);
}

export function setWarMemo(a: Ctx, v: WarMemo | null): void {
  writeMemo(a, WAR_KEY, v);
}
